module.exports = __webpack_public_path__ + "img/cebf961.jpg";